import React from 'react'
import QueryTable from './QueryTable'
import BasicLayout from 'components/BasicLayout'

function QuerySection() {

  const SampleComponent = BasicLayout(QueryTable)
  return (
    <SampleComponent />
  )
}

export default QuerySection